import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Card, Tabs, Tab, Row, Col, Badge, Button } from 'react-bootstrap';
import { useQuery } from 'react-query';
import moment from 'moment';
import { LOPHUONGDANTHUCHANH_TRIENKHAI_API } from '../../../utils/apiUrl';
import { URI_INTERNAL } from '../../../utils/pathLocations';
import { Get } from '../../../utils/httpProvider';

import StudentThucHanhTab from './components/StudentThucHanhTab';
import TutorThucHanhTab from './components/TutorThucHanhTab';
import ScheduleThucHanhTab from './components/ScheduleThucHanhTab';
import AttendanceThucHanhTab from './components/AttendanceThucHanhTab';
import BangDanhGiaThucHanhTab from './components/BangDanhGiaThucHanhTab';

const LopHuongDanThucHanhDetail = () => {
    const { id } = useParams();
    const history = useHistory();
    const [activeTab, setActiveTab] = useState('students');

    const { data: lopDetail, isLoading } = useQuery(
        ['lopHuongDanThucHanhDetail', id],
        () => Get(`${LOPHUONGDANTHUCHANH_TRIENKHAI_API.GET_ITEM}/${id}`),
        { 
            enabled: !!id,
            staleTime: 0,
            cacheTime: 0
        }
    );

    if (isLoading) {
        return <div className="p-4 text-center">Đang tải thông tin lớp học...</div>;
    }

    if (!lopDetail) {
        return (
            <div className="p-4 text-center">
                <h5>Không tìm thấy lớp hướng dẫn thực hành.</h5>
                <Button variant="primary" onClick={() => history.push(URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_PATH)}>
                    Quay lại danh sách
                </Button>
            </div>
        );
    }

    return (
        <div className="p-2 p-md-3">
            {/* DESKTOP VIEW (>= 768px) */}
            <div className="d-none d-md-block">
                {/* Header thông tin lớp */}
                <Card className="shadow-sm border-0 mb-3">
                    <Card.Body>
                        <Row className="align-items-center">
                            <Col md={8}>
                                <div className="d-flex align-items-center mb-2">
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        className="mr-3"
                                        onClick={() => {
                                            if (window.history.length > 1) {
                                                history.goBack();
                                            } else {
                                                history.push(URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_PATH);
                                            }
                                        }}
                                    >
                                        <i className="fas fa-arrow-left mr-1"></i> Quay lại
                                    </Button>
                                    <h4 className="mb-0 text-primary font-weight-bold">{lopDetail.tenKhoaHoc}</h4>
                                </div>
                                <div className="text-muted small">
                                    <span className="mr-3">
                                        <i className="fas fa-file-alt mr-1"></i>
                                        Số QĐ: <strong>{lopDetail.soQuyetDinh || "Chưa có"}</strong>
                                    </span>
                                    <span className="mr-3">
                                        <i className="fas fa-calendar-alt mr-1"></i>
                                        Khai giảng: <strong>{lopDetail.ngayKhaiGiang ? moment(lopDetail.ngayKhaiGiang).format('DD/MM/YYYY') : "—"}</strong>
                                    </span>
                                    <span className="mr-3">
                                        <i className="fas fa-calendar-check mr-1"></i>
                                        Bế giảng: <strong>{lopDetail.ngayBeGiang ? moment(lopDetail.ngayBeGiang).format('DD/MM/YYYY') : "—"}</strong>
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Các Tabs nghiệp vụ Desktop */}
                <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="custom-nav-tabs mb-3">
                    <Tab
                        eventKey="students"
                        title={
                            <span>
                                <i className="fas fa-users mr-1"></i> Danh Sách Học Viên ({lopDetail.soLuongHocVienThucTe || 0})
                            </span>
                        }
                    >
                        <StudentThucHanhTab lopId={id} />
                    </Tab>

                    <Tab
                        eventKey="tutors"
                        title={
                            <span>
                                <i className="fas fa-chalkboard-teacher mr-1"></i> Đội Ngũ Giảng Viên ({lopDetail.soLuongGiangVien || 0})
                            </span>
                        }
                    >
                        <TutorThucHanhTab lopId={id} />
                    </Tab>

                    <Tab
                        eventKey="schedule"
                        title={
                            <span>
                                <i className="fas fa-calendar-alt mr-1"></i> Quản Lý Lịch Học
                            </span>
                        }
                    >
                        <ScheduleThucHanhTab lopId={id} />
                    </Tab>

                    <Tab
                        eventKey="admin_attendance"
                        title={
                            <span>
                                <i className="fas fa-clipboard-check mr-1"></i> Điểm Danh Lớp (Quản Trị)
                            </span>
                        }
                    >
                        <AttendanceThucHanhTab lopId={id} />
                    </Tab>

                    <Tab
                        eventKey="danhgia"
                        title={
                            <span>
                                <i className="fas fa-file-signature mr-1"></i> Bảng Đánh Giá Theo Đợt
                            </span>
                        }
                    >
                        <BangDanhGiaThucHanhTab lopId={id} />
                    </Tab>
                </Tabs>
            </div>

            {/* MOBILE VIEW (< 768px) CHUẨN ĐÀO TẠO LIÊN TỤC */}
            <div className="d-block d-md-none">
                {/* Mobile Top App Bar */}
                <div className="d-flex align-items-center justify-content-between mb-2 px-1">
                    <div
                        className="d-flex align-items-center text-dark font-weight-bold"
                        style={{ fontSize: '16px', cursor: 'pointer' }}
                        onClick={() => {
                            if (window.history.length > 1) {
                                history.goBack();
                            } else {
                                history.push(URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_PATH);
                            }
                        }}
                    >
                        <i className="fas fa-chevron-left mr-2" style={{ fontSize: '15px' }}></i>
                        <span>
                            {activeTab === 'schedule'
                                ? 'Quản lý lịch học'
                                : activeTab === 'students'
                                ? 'Danh sách học viên'
                                : activeTab === 'tutors'
                                ? 'Đội ngũ giảng viên'
                                : activeTab === 'admin_attendance'
                                ? 'Điểm danh lớp'
                                : 'Bảng đánh giá theo đợt'}
                        </span>
                    </div>
                    <div className="text-muted" style={{ cursor: 'pointer', padding: '4px 8px' }}>
                        <i className="fas fa-ellipsis-h" style={{ fontSize: '16px' }}></i>
                    </div>
                </div>

                {/* Mobile Class Card Banner */}
                <div className="bg-white rounded-lg p-3 mb-2 border shadow-sm" style={{ borderRadius: '12px', borderColor: '#e2e8f0' }}>
                    <div className="font-weight-bold mb-1" style={{ color: '#2563eb', fontSize: '15px', lineHeight: '1.3' }}>
                        {lopDetail.tenKhoaHoc}
                    </div>
                    <div className="text-muted small mb-2" style={{ fontSize: '12px' }}>
                        {lopDetail.soQuyetDinh ? `${lopDetail.soQuyetDinh} · ` : ''}
                        Khai giảng {lopDetail.ngayKhaiGiang ? moment(lopDetail.ngayKhaiGiang).format('DD/MM/YYYY') : '—'} · {lopDetail.soLuongHocVienThucTe || 0} học viên
                    </div>
                    <div>
                        <span
                            className="badge px-2 py-1 font-weight-500"
                            style={{
                                backgroundColor: '#e0f2fe',
                                color: '#0284c7',
                                borderRadius: '6px',
                                fontSize: '11px'
                            }}
                        >
                            Quản trị thực hành
                        </span>
                    </div>
                </div>

                {/* Mobile Tabs Bar */}
                <div
                    className="d-flex overflow-auto mb-3 bg-white border-bottom"
                    style={{ whiteSpace: 'nowrap', WebkitOverflowScrolling: 'touch', gap: '4px' }}
                >
                    <button
                        type="button"
                        className={`btn btn-sm py-2 px-3 font-weight-500 border-0 ${activeTab === 'students' ? 'text-primary border-bottom border-primary font-weight-bold' : 'text-muted'}`}
                        style={{
                            borderRadius: 0,
                            borderBottom: activeTab === 'students' ? '2px solid #2563eb' : 'none',
                            fontSize: '13px'
                        }}
                        onClick={() => setActiveTab('students')}
                    >
                        Học viên
                    </button>
                    <button
                        type="button"
                        className={`btn btn-sm py-2 px-3 font-weight-500 border-0 ${activeTab === 'tutors' ? 'text-primary border-bottom border-primary font-weight-bold' : 'text-muted'}`}
                        style={{
                            borderRadius: 0,
                            borderBottom: activeTab === 'tutors' ? '2px solid #2563eb' : 'none',
                            fontSize: '13px'
                        }}
                        onClick={() => setActiveTab('tutors')}
                    >
                        Giảng viên
                    </button>
                    <button
                        type="button"
                        className={`btn btn-sm py-2 px-3 font-weight-500 border-0 ${activeTab === 'schedule' ? 'text-primary border-bottom border-primary font-weight-bold' : 'text-muted'}`}
                        style={{
                            borderRadius: 0,
                            borderBottom: activeTab === 'schedule' ? '2px solid #2563eb' : 'none',
                            fontSize: '13px'
                        }}
                        onClick={() => setActiveTab('schedule')}
                    >
                        Lịch học
                    </button>
                    <button
                        type="button"
                        className={`btn btn-sm py-2 px-3 font-weight-500 border-0 ${activeTab === 'admin_attendance' ? 'text-primary border-bottom border-primary font-weight-bold' : 'text-muted'}`}
                        style={{
                            borderRadius: 0,
                            borderBottom: activeTab === 'admin_attendance' ? '2px solid #2563eb' : 'none',
                            fontSize: '13px'
                        }}
                        onClick={() => setActiveTab('admin_attendance')}
                    >
                        Điểm danh
                    </button>
                    <button
                        type="button"
                        className={`btn btn-sm py-2 px-3 font-weight-500 border-0 ${activeTab === 'danhgia' ? 'text-primary border-bottom border-primary font-weight-bold' : 'text-muted'}`}
                        style={{
                            borderRadius: 0,
                            borderBottom: activeTab === 'danhgia' ? '2px solid #2563eb' : 'none',
                            fontSize: '13px'
                        }}
                        onClick={() => setActiveTab('danhgia')}
                    >
                        Đánh giá
                    </button>
                </div>

                {/* Mobile Tab Content */}
                <div>
                    {activeTab === 'students' && <StudentThucHanhTab lopId={id} />}
                    {activeTab === 'tutors' && <TutorThucHanhTab lopId={id} />}
                    {activeTab === 'schedule' && <ScheduleThucHanhTab lopId={id} />}
                    {activeTab === 'admin_attendance' && <AttendanceThucHanhTab lopId={id} />}
                    {activeTab === 'danhgia' && <BangDanhGiaThucHanhTab lopId={id} />}
                </div>
            </div>
        </div>
    );
};

export default LopHuongDanThucHanhDetail;
